import './note.list.detail.scss';

import { Card, CardContent, Divider, Link, Typography } from '@mui/material';

import { ConvergeTooltip } from '../../presentation';
import { NotesListDetailData } from '@converge/graphql';
import { Stack } from '@mui/system';
import { marked } from 'marked';
import moment from 'moment';

marked.setOptions({
  gfm: true, // Enable GitHub Flavored Markdown features including strikethrough
});
export interface INoteDetailProps {
  note: NotesListDetailData;
}

export const NoteListDetail = ({
  note: {
    createdAt,
    user: {
      node: { username },
    },
    note,
  },
}: INoteDetailProps) => {
  const renderedMarkdown = marked(note ?? 'N/A');
  return (
    <Card className="note-list-detail">
      <CardContent>
        <div dangerouslySetInnerHTML={{ __html: renderedMarkdown }} />
      </CardContent>
      <Divider />
      <CardContent>
        <Stack className="card-container">
          <Typography className="typography-style">
            <Link
              href={`mailto:${username}`}
              sx={{
                color: 'initial',
                textDecoration: 'none',
                ':hover': {
                  textDecoration: 'underline',
                },
              }}
            >
              {username}
            </Link>
          </Typography>
          <Typography className="typography-style typography-style-bullet">
            &bull;
          </Typography>
          <ConvergeTooltip title={moment(createdAt).format('LLLL')}>
            <Typography color="CaptionText">
              {moment(createdAt).fromNow()}
            </Typography>
          </ConvergeTooltip>
        </Stack>
      </CardContent>
    </Card>
  );
};
